// extracted by mini-css-extract-plugin
export default {"column":"rates_table_header_column_column__yGzr4","columnContent":"rates_table_header_column_columnContent__4JzPE","columnLabel":"rates_table_header_column_columnLabel__pb2TD"};